import { colors } from '../tailwind'

export function stringToHslColor(str = '', s = 30, l = 50) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  const h = hash % 360
  return 'hsl(' + h + ', ' + s + '%, ' + l + '%)'
}

export const extendColors = (
  type:
    | 'primary'
    | 'tertiary'
    | 'secondary'
    | 'neutral'
    | 'grays'
    | 'success'
    | 'error'
    | 'warning'
    | 'decorative'
    | 'tag'
    | 'lead',
  colorsConfig: any
) => {
  colors[type] = { ...colors[type], ...colorsConfig }
}
